import React from "react";
import "../styles/BelMailOns.css";

const BelMailOns = ({ show, onClose, title, email, phone }) => {
  if (!show) return null;

  return (
    <div className="belMailOnsOverlay">
      <div className="belMailOnsModal">
        <h2>Bel of Mail ons:</h2>
        <p>Neem contact met ons op via:</p>
        <div className="contactDetails">
          <a href={`tel:${phone}`} className="contactLink">
            {phone}
          </a>
          <br />
          <a href={`mailto:${email}`} className="contactLink">
            {email}
          </a>
        </div>
        <button className="closeButton" onClick={onClose}>
          Sluiten
        </button>
      </div>
    </div>
  );
};

export default BelMailOns;
